export class CoreUtils {
  static debounce = <T extends (...args: any[]) => void>(callback: T, wait: number): ((...args: Parameters<T>) => void) => {
    let timeoutId: NodeJS.Timeout | null = null;

    return (...args: Parameters<T>): void => {
      if (timeoutId !== null) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(...args), wait);
    };
  };

  static capitalize = <T extends string>(s: T) => (s[0].toUpperCase() + s.slice(1)) as Capitalize<typeof s>;
}
